module.exports = __webpack_public_path__ + "infocentrum11.jpg?808a7c9c1bf108ab086c401994b78f0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum11.jpg
// module id = 263
// module chunks = 0